import { render, staticRenderFns } from "./HomeMain.vue?vue&type=template&id=6af1a97d&scoped=true&"
import script from "./HomeMain.vue?vue&type=script&lang=js&"
export * from "./HomeMain.vue?vue&type=script&lang=js&"
import style0 from "./HomeMain.vue?vue&type=style&index=0&id=6af1a97d&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6af1a97d",
  null
  
)

export default component.exports